/**
 * SURVEY-SELECT.WIDGET.TSX
 * Select survey from a list
 */

import { connect } from "react-redux"
import { store } from "@/index"
import { WithTranslation, withTranslation } from "react-i18next"
import { surveyActivate, surveyFetch, surveyGet } from "@/redux/survey.actions"
import { Survey, SurveyState } from "@/redux/survey.types"
import { useEffect } from "react"
import ListDropdown from "@/components/list-dropdown"

interface StateProps extends WithTranslation {
  survey: SurveyState
}

function SurveySelectWidget(props: StateProps) {
  const { t } = props

  //Load surveys
  useEffect(() => {
    load()
    async function load() {
      const response: any = await store.dispatch(surveyFetch())
      store.dispatch(surveyGet(response.error ? [] : response, [], false))
    }
  }, [])

  return (
    <div className="flex">
      <div className="grey-t">{t("tasks_survey")}&nbsp;:&nbsp;</div>
      <ListDropdown
        isBold
        isCaretAlwaysVisible
        value={props.survey.active.name}
        active={props.survey.active.id}
        values={props.survey.list.filter((x) => !x.isTest)}
        onSelect={(survey: Survey) => store.dispatch(surveyActivate(survey))}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  survey: state.survey
})

export default connect(mapStateToProps)(withTranslation()(SurveySelectWidget))
